






















































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { useWorkFlow } from '../composables';
import { FitViewParams, PanelPositionType } from '../types';

import WorkflowPanel from '../components/Panel/Panel.vue';

export interface ControlProps {
  /** Show the zoom icon */
  showZoom?: boolean;
  /** Show the fit-view icon */
  showFitView?: boolean;
  /** Show the interactive icon */
  showInteractive?: boolean;
  /** Params to use on fitView */
  fitViewParams?: FitViewParams;
  /** Position of the controls {@link PanelPositionType} */
  position?: PanelPositionType;
}

export default defineComponent<ControlProps>({
  name: 'WorkflowPaneControls',

  components: {
    WorkflowPanel
  },

  props: {
    showZoom: { default: true },
    showFitView: { default: true },
    showInteractive: { default: true },
    // fitViewParams: { type: Object as PropType<FitViewParams> },
    position: {
      type: String as PropType<PanelPositionType>,
      default: 'bottom-left'
    }
  },

  emits: ['zoomIn', 'zoomOut', 'fitView', 'interactionChange'],

  setup(_props, { emit }) {
    const {
      nodesDraggable,
      nodesConnectable,
      elementsSelectable,
      setInteractive,
      zoomIn,
      zoomOut,
      fitView,
      viewport,
      minZoom,
      maxZoom
    } = useWorkFlow();

    const isInteractive = computed(
      () =>
        nodesDraggable.value ||
        nodesConnectable.value ||
        elementsSelectable.value
    );

    const minZoomReached = computed(() => viewport.value.zoom <= minZoom.value);

    const maxZoomReached = computed(() => viewport.value.zoom >= maxZoom.value);

    function onZoomInHandler() {
      zoomIn({ duration: 300 });

      emit('zoomIn');
    }

    function onZoomOutHandler() {
      zoomOut({ duration: 300 });

      emit('zoomOut');
    }

    function onFitViewHandler() {
      fitView({ duration: 300 });

      emit('fitView');
    }

    function onInteractiveChangeHandler() {
      setInteractive(!isInteractive.value);

      emit('interactionChange', !isInteractive.value);
    }

    return {
      isInteractive,
      minZoomReached,
      maxZoomReached,

      onZoomInHandler,
      onZoomOutHandler,
      onFitViewHandler,
      onInteractiveChangeHandler
    };
  }
});
